import { useState } from "react";
import "../App.css";

const TodoAdd = ({ addTask }) => {
  const [task, setTask] = useState("");
  const [time, setTime] = useState("");

  const handleAdd = () => {
    if (task.trim() === "" || time === "") return;

    addTask({ text: task, time: time });
    setTask("");
    setTime("");
  };

  return (
    <div className="input-box">
      <input
        type="text"
        placeholder="Enter task..."
        value={task}
        onChange={(e) => setTask(e.target.value)}
      />

      <input
        type="time"
        value={time}
        onChange={(e) => setTime(e.target.value)}
      />

      <button onClick={handleAdd}>Add</button>
    </div>
  );
}

export default TodoAdd;
